module.exports = __webpack_public_path__ + "static/media/logo.1bca7b53.png";